import { Component, OnInit } from '@angular/core';
import { ObtenerDatosService } from '../../../../servicios/datos/obtener-datos/obtener-datos.service';
import { GlobalesService } from 'src/app/servicios/globales.service';

import { ThemeService } from '../../../../theme/theme.service';

@Component({
  selector: 'app-pregunta-representacion-proporcional',
  templateUrl: './pregunta-representacion-proporcional.component.html',
  styleUrls: ['./pregunta-representacion-proporcional.component.scss']
})
export class PreguntaRepresentacionProporcionalComponent implements OnInit {

  Search = "";
  constructor(public readonly _obtenerDatosService : ObtenerDatosService, public _globalService: GlobalesService,public themeService: ThemeService,) { }

  ngOnInit(): void {
    this._globalService.searchItem.subscribe(data =>{
      if(data == null) return;
      this.Search = data
    });
  }

}
